import FilterButton from 'Organisms/TableHeaderActionButtons/FilterButton';
import { useState } from 'react';
import DashboardFiltersPanel from './DashboardFiltersPanel';

const DashboardFiltersButton = () => {
  const [isFiltersPanelOpen, setIsFiltersPanelOpen] = useState<boolean>(false);

  return (
    <>
      <FilterButton
        onToggleFilter={() => setIsFiltersPanelOpen(true)}
        aria-pressed={isFiltersPanelOpen}
        data-cy='dashboard-detail__filter-button'
      />
      <DashboardFiltersPanel
        isOpen={isFiltersPanelOpen}
        onClose={() => setIsFiltersPanelOpen(false)}
      />
    </>
  );
};

export default DashboardFiltersButton;
